//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    activeIndex: {
      type: [Number, String],
      default: 0
    }
  },
  data () {
    return {
      list: [
        {
          title: 'TYY_000706',
          ids: [0, 1],
          links: [
            {
              id: 0,
              text: '40328',
              link: `/${this.currLangCode()}/help/instructions-for-using-vps.html`
            },
            {
              id: 1,
              text: '40314',
              link: `/${this.currLangCode()}/help/vps-product-classification.html`
            }
          ],
          icon1: [`${require('~/assets/img/help/2024517-icon1.svg')}`, `${require('~/assets/img/help/2024517-icon1-active.svg')}`]
        }, {
          title: '40315',
          ids: [2],
          links: [
            {
              id: 2,
              text: '40317',
              link: `/${this.currLangCode()}/help/buy-vps-server-process.html`
            }
          ],
          icon1: [`${require('~/assets/img/help/2024517-icon2.svg')}`, `${require('~/assets/img/help/2024517-icon2-active.svg')}`]
        }, {
          title: '40320',
          ids: [3, 4],
          links: [
            {
              id: 3,
              text: '40322',
              link: `/${this.currLangCode()}/help/helpWin.html`
            },
            {
              id: 4,
              text: '40323',
              link: `/${this.currLangCode()}/help/helpMac.html`
            }
          ],
          icon1: [`${require('~/assets/img/help/2024517-icon3.svg')}`, `${require('~/assets/img/help/2024517-icon3-active.svg')}`]
        }, {
          title: '40324',
          ids: [5, 6, 7],
          links: [
            {
              id: 5,
              text: '40326',
              link: `/${this.currLangCode()}/help/mt4-account-binding-process.html`
            }, {
              id: 6,
              text: '40326',
              link: `/${this.currLangCode()}/help/mt5-account-binding-process.html`
            }, {
              id: 7,
              text: '40326',
              link: `/${this.currLangCode()}/help/ctrader-account-binding-process.html`
            }
          ],
          icon1: [`${require('~/assets/img/help/2024517-icon4.svg')}`, `${require('~/assets/img/help/2024517-icon4-active.svg')}`]
        }
      ]
    }
  },
  created () {
    // {
    //           id: 8,
    //           text: '40327',
    //           link: `/${this.currLangCode()}/help/helpIssueVps.html`
    //         }
  },
  mounted () {
    // console.log(this.activeIndex)
  },
  methods: {
    getText (index, index1, text1) {
      if (index == 3 && index1 == 0) return text1.replace('{0}', 'MT4')
      else if (index == 3 && index1 == 1) return text1.replace('{0}', 'MT5')
      else if (index == 3 && index1 == 2) return text1.replace('{0}', 'cTrader')
      else return text1
    }
  }
}
